// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"376":"d1d04152","453":"dab9198d"}[chunkId] + ".chunk.js";
};